(function() {
	var ISO_8601_DATE = /^\d\d\d\d-\d\d-\d\d$/;
	var US_DATE = /^[\d]{1,2}\/[\d]{1,2}\/[\d]{4}$/;
	var VALID_EMAIL_REGEX = /^[a-zA-Z0-9_.+\-$']+@[a-zA-Z0-9-]+\.[a-zA-Z0-9][a-zA-Z0-9\-\.]*[a-zA-Z0-9]$/

	var FormValidator = function(form) {
		var self = this;
		this.form = $(form);
		this.form.delegate('input, select', 'blur', function() {
			self.validateField(this);
		});
	};

	FormValidator.messages = {
		required: 'Please fill out this field',
		invalid_number: 'Please enter a number'
	};

	FormValidator.prototype = {

		isValid: function() {
			var valid = true, self = this;
			this.form.find('input, select').each(function(i, elem) {
				if(self.validateField(elem) !== null) {
					valid = false;
				}
			});
			return valid;
		},

		validateField: function(element) {
			element = $(element);
			var err = null;
			if(element.prop('tagName') === 'INPUT') {
				err = this._validateInput(element);
				this._updateInputTooltip(element, err);
			}
			return err;
		},

		_validateInput: function(input) {
			if (input.attr('required_group')) {
				return this._validateRequiredGroupInput(input);
			}

			if(input.val() == '') {
				return input.attr('required') ? FormValidator.messages.required : null;
			}

			if (input.attr('unique')) {
				return this._validateUniqueInput(input);
			}

			var type = input.attr('type'), err = null;
			if(type == 'number') {
				err = this._validateNumberInput(input);
			}
			else if(type == 'date') {
				err = this._validateDateInput(input);
			}
			else if (type == 'email') {
				err = this._validateEmailInput(input);
			}

			return err;
		},

		_validateNumberInput: function(input) {
			var n = parseFloat(input.val());
			var min = input.attr('min'), max = input.attr('max');
			if(isNaN(n)) {
				return FormValidator.messages.invalid_number;
			}
			else if(min && parseFloat(min) > n) {
				return "Value must be greater than or equal to " + min;
			}
			else if(max && parseFloat(max) < n) {
				return "Value must be less than or equal to " + max;
			}

			if (input.attr('step') == '1' && n % 1 != 0) {
				return "Must be a whole number"
			}

			return null;
		},

		_validateDateInput: function(input) {
			var dateString = input.val();
			if(dateString.match(ISO_8601_DATE)) {
				timestamp = Date.parse(dateString);
			}
			else if(dateString.match(US_DATE)) {
				var parts = dateString.split('/');
				timestamp = Date.parse(parts[2] + '-' + parts[0] + '-' + parts[1]);
			}
			else {
				return "Please enter a valid date.";
			}

			var min = input.attr('min'), max = input.attr('max');
			if(min && Date.parse(min) > timestamp) {
				return "Date must be " + min.substr(0, 10) + " or later.";
			}
			else if(max && Date.parse(max) < timestamp) {
				return "Date must be " + max.substr(0, 10) + " or before.";
			}
			return null;
		},

		_validateEmailInput: function (input) {
			var emailString = input.val();
			if (!emailString.match(VALID_EMAIL_REGEX)) {
				return "Must be a valid email address"
			}

			return null
		},
		
		// If any elements with a required_group have a value, then all elements with 
		// the same required_group where required_group_required=true must also have a value
		_validateRequiredGroupInput: function(input) {
			var required = input.attr('required_group_required') == "true";
			var blank = input.val() == '';
			var all_blank = true;
			var all_requried_fields_blank = true;
			this.form.find('input[required_group="' + input.attr('required_group') + '"]').each(function(){
				if($(this).val() != '') {
					all_blank = false;
					if ($(this).attr('required_group_required') === "true") {
						all_requried_fields_blank = false;
					}
				}
			});
			if (all_blank) {
				return null;
			} else if (blank && required) {
				return FormValidator.messages.required;
			}
			return null;
		},

		// All element with the same 'unique' attribute must have unique values (or no value)
		_validateUniqueInput: function(input) {
			let uniqueGroup = input.attr('unique')
			let isUnique = true

			this.form.find('input[unique="' + uniqueGroup + '"]').each(function() {
				if (input.is($(this))) return true
				if (input.val() == $(this).val()) {
					isUnique = false
					return false
				}
			})

			return isUnique ? null : 'Must be unique'
		},

		_updateInputTooltip: function(input, msg) {
			var prevMsg = input.data('error');
			input.data('error', msg);

			var tooltipExists = !!input.data('bs.tooltip');

			if(msg) {
				input.parent().addClass('has-error');
				if(!tooltipExists) {
					// Create the tooltip
					input.tooltip({ title: msg }).tooltip('show');
				}
				else if(msg != prevMsg) {
					// The error message has changed - update the tooltip
					input.attr('data-original-title', msg)
						.tooltip('fixTitle')
						.tooltip('show');
				}
			}
			else if(tooltipExists) {
				input.parent().removeClass('has-error');
				input.tooltip('destroy');
			}
		}
	};

	C.FormValidator = FormValidator;

})();
